module.exports = "<nb-card size=\"xsmall\">\r\n    <nb-card-header>\r\n      <span>Traffic Consumption</span>\r\n    </nb-card-header>\r\n  </nb-card>\r\n"